import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const HintTitleStyled = styled(Stack)({
  paddingTop: 8,
  paddingBottom: 8,
});
